/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 上市公司财务情况概览----行业分布情况
 */
import styles from './industry.scss';
import commonStyles from '../common/common.scss';
import scatterActivePNG from '../../../../images/scatterActive.png';
import React, {PureComponent} from 'react';
import {Col, Row, Spin} from 'antd';
import {isNotEmpty, keyToText, paramFilter} from '../../../../utils/util';
import {fieldAnomaly, numberFixed} from '../../../../utils/formatter';
import cancel from '../../../../utils/cancel';
import BBDAxisScatter from '../../../common/echarts/BBDAxisScatter';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import BBDPie from '../../../common/echarts/BBDPie';
import ScoresRanking from '../../../common/scoresRanking/ScoresRanking';
import NoData from '../../../common/noData/NoData';
import { formatIndScatterData, formatGeoTrendOption, formatGeoPieData } from '../common/formatEchartOption';
import SearchForm from './common/SearchForm';
import {getIndustryCensus, getIndustryRank, getIndustryTrend, getIndustrySpread} from '../../../../services/regulatoryStatistical';

@cancel
export default class Industry extends PureComponent {
    constructor(props) {
        super(props);
        this.scatterEvents = { click: this.onIndSelect };
        this.state = {
            searchParams: {},
            selectedIndustry: {},
            scatterLoading: true,
            rankLoading: true,
            trendLoading: true,
            pieLoading: true,
            statisticText: '',
            scatterOption: [],
            rankData: [],
            lineOption: [],
            pieOption: []
        };
    }

    resetLoading = () => {
        this.setState({
            scatterLoading: false,
            rankLoading: false,
            trendLoading: false,
            pieLoading: false
        });
    };

    onSearch = (searchParams) => {
        this.setState({
            selectedIndustry: {},
            searchParams,
            statisticText: keyToText(searchParams.statisticType, this.props.options.riskFakeTypes)
        }, () => {
            this.getIndustryCensus();
            this.getIndustryRank();
            this.getTrend();
            this.getPie();
        });
    };

    // 获取散点图数据
    getIndustryCensus = () => {
        let { searchParams } = this.state;

        this.doCancel('census');
        this.setState({
            scatterLoading: true
        });
        getIndustryCensus(paramFilter({ ...searchParams }), this.addCancel('census')).then(data => {
            data = data || [];
            this.setState({
                scatterLoading: false,
                scatterOption: formatIndScatterData(data)
            });
        }).catch(() => {
            this.setState({
                scatterLoading: false,
                scatterOption: {},
                top5: []
            });
        });
    };

    // 获取TOP5数据
    getIndustryRank = () => {
        const { searchParams, selectedIndustry } = this.state;
        const { industryCode } = selectedIndustry;

        this.setState({
            rankLoading: true
        });
        getIndustryRank(paramFilter({ ...searchParams, industryCode })).then(data => {
            data = data || [];
            this.setState({
                rankLoading: false,
                rankData: data.map((d) => ({ name: d.sesName, value: numberFixed(d.tScore) }))
            });
        }).catch(() => {
            this.setState({
                rankLoading: false,
                rankData: []
            });
        });
    };

    // 获取折线数据
    getTrend = () => {
        const { searchParams, selectedIndustry } = this.state;
        const { industryCode } = selectedIndustry;

        this.doCancel('trend');
        this.setState({
            trendLoading: true
        });
        getIndustryTrend(paramFilter({ ...searchParams, industryCode }), this.addCancel('trend')).then(data => {
            data = data || [];
            this.setState({
                trendLoading: false,
                lineOption: formatGeoTrendOption(data, ['endDate', 'industryAverage', 'exceedTotal'])
            });
        }).catch(() => {
            this.setState({
                trendLoading: false,
                lineOption: {}
            });
        });
    };

    // 获取饼图
    getPie = () => {
        const { searchParams, selectedIndustry } = this.state;
        const { industryCode } = selectedIndustry;

        this.doCancel('pie');
        this.setState({
            pieLoading: true
        });
        getIndustrySpread(paramFilter({ ...searchParams, industryCode }), this.addCancel('pie')).then(data => {
            data = data || [];
            this.setState({
                pieLoading: false,
                pieOption: formatGeoPieData(
                    data,
                    ['provinceName', 'count', 'average'],
                    function (param) {
                        return `${param.name} <br />评分均值：${fieldAnomaly(param.data.score)}<br />公司数目：${param.data.value}家`;
                    }
                )
            });
        }).catch(() => {
            this.setState({
                pieLoading: false,
                pieOption: {}
            });
        });
    };

    // 选择行业
    onIndSelect = (e) => {
        let { scatterOption } = this.state;
        let selectedIndustry = {};
        if(!e.data) {
            return;
        }
        selectedIndustry = e.data.selected ? {} : e.data;
        scatterOption.data.forEach((d) => {
            d.selected = d.industryName === selectedIndustry.industryName;
            d.symbol = d.selected ? `image://${scatterActivePNG}` : undefined; // 设置了visualMap后，改变颜色无效，只能换图形
        });
        scatterOption.notMerge = false;
        delete scatterOption.dataZoom;

        this.setState({ selectedIndustry, scatterOption: { ...scatterOption } }, () => {
            delete scatterOption.notMerge;
            this.getIndustryRank();
            this.getTrend();
            this.getPie();
        });
    };

    render() {
        const { options } = this.props;
        const { scatterOption, rankData, lineOption, pieOption,
            scatterLoading, rankLoading, trendLoading, pieLoading, statisticText, selectedIndustry } = this.state;
        const { industryName = '' } = selectedIndustry;
        const selectedIndName = industryName.replace(/业$/, '');

        return (
            <div>
                <img src={scatterActivePNG} className="hide"/>
                <Row>
                    <Col span={15}>
                        <SearchForm options={options} onSearch={this.onSearch} onFail={this.resetLoading}/>
                        <div className={styles.scatterEchart}>
                            { scatterLoading ?
                                <Spin /> :
                                isNotEmpty(scatterOption) ?
                                    <BBDAxisScatter option={scatterOption} onEvents={this.scatterEvents}/> :
                                    <NoData />
                            }
                        </div>
                    </Col>
                    <Col span={9}>
                        <div className={commonStyles.wrap}>
                            <p className="wrap-title">{selectedIndName}行业{statisticText}公司TOP5</p>
                            <div className={styles.progressList}>
                                { rankLoading ?
                                    <Spin /> :
                                    rankData.length ?
                                        <ScoresRanking data={rankData} /> :
                                        <NoData />
                                }
                            </div>
                        </div>

                        <div className={commonStyles.wrap}>
                            <p className="wrap-title">{selectedIndName}行业{statisticText}趋势</p>
                            <div className={styles.trendEchart}>
                                { trendLoading ?
                                    <Spin /> :
                                    isNotEmpty(lineOption) ?
                                        <BBDLineBar option={lineOption}/> :
                                        <NoData />
                                }
                            </div>
                        </div>

                        <div className={commonStyles.wrap}>
                            <p className="wrap-title">{selectedIndName}行业地域分布</p>
                            <div className={styles.pieEchart}>
                                { pieLoading ?
                                    <Spin /> :
                                    isNotEmpty(pieOption) ?
                                        <BBDPie option={pieOption}/> :
                                        <NoData />
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/financialOverview/Industry.jsx